// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Symbol_symbol__R8WTd{
    width: 80%;
    height: 80%;
    margin-left: 10%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/Tabs/RefundPolicy/Symbol.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".symbol{\n    width: 80%;\n    height: 80%;\n    margin-left: 10%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"symbol": `Symbol_symbol__R8WTd`
};
export default ___CSS_LOADER_EXPORT___;
